import {IDynamicSiteItem, ModType} from '../_components/LazyLoading';

export const index: IDynamicSiteItem = {
  [ModType.FRONTEND_EXEC]: () => import('./js/eventHooks'),
};
export default index;
